import { IIconBase } from '..'

const arrowDownIcon = ({
  color = '#333752',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.28 6.46875L8.9333 10.8154C8.41997 11.3288 7.57997 11.3288 7.06664 10.8154L2.71997 6.46875'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default arrowDownIcon
